module.exports = __webpack_public_path__ + "img/element-auth_form.1ea6df2.svg";